var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cls from 'classnames';
import { formatPrice } from '../utils/formatPrice';
import { useSelector } from '../store/useSelector';
export function Odds(_a) {
    var { className, onClick, disabled, ap, ep, sp, gp, lp, selected, currentPriceNum, currentPriceDen, fallback, stopPropagation } = _a, props = __rest(_a, ["className", "onClick", "disabled", "ap", "ep", "sp", "gp", "lp", "selected", "currentPriceNum", "currentPriceDen", "fallback", "stopPropagation"]);
    const priceFormat = useSelector((state) => state.priceFormat);
    const click = (event) => {
        event.preventDefault();
        if (stopPropagation) {
            event.stopPropagation();
        }
        if (onClick) {
            onClick();
        }
    };
    const specialOdds = ap || ep || sp || gp || lp;
    const finalDisabled = disabled || (!specialOdds && (!currentPriceNum || !currentPriceDen));
    const formattedPrice = formatPrice(priceFormat, currentPriceNum, currentPriceDen) || fallback;
    const output = ap ? 'AP' : sp ? 'SP' : gp ? 'GP' : lp ? 'LP' : ep ? 'EP' : formattedPrice;
    const finalClassName = cls('WhSearch-Odds', className, {
        'WhSearch-Odds--disabled': finalDisabled,
        'WhSearch-Odds--selected': selected,
    });
    return (React.createElement("div", Object.assign({ className: finalClassName, onClick: click }, props), output));
}
//# sourceMappingURL=Odds.js.map